import { createEntityAdapter } from '@reduxjs/toolkit';
import IUser from 'types/superadmin/ISuperAdmin';

const superAdminsAdapter = createEntityAdapter<IUser>({
  selectId: superAdmin => superAdmin.id,
});

export default superAdminsAdapter;
